import {COUNTRIES} from "./countriers";
import {CITIES} from "./cities";

const GeoService = {
    COUNTRIES,
    CITIES,
}

export default GeoService;